var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Flex from "@irati/ui/src/Flex";
import Icon from "@irati/ui/src/Icon";
import padding from "@irati/ui/src/global/padding";
export var TickImage = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n"], ["\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n"])));
export var PerksGOImage = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 80px;\n  height: 52px;\n  display: block;\n  margin: ", ";\n"], ["\n  width: 80px;\n  height: 52px;\n  display: block;\n  margin: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.two + " auto";
});
export var PerksGOBackground = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  margin: 30px -", ";\n\n  ", "\n\n  ", "\n"], ["\n  ", "\n  margin: 30px -", ";\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return "background: " + theme.colors.greys.lightest + ";";
}, padding.small, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-left: -", ";\n    margin-right: -", ";\n  "], ["\n    margin-left: -", ";\n    margin-right: -", ";\n  "])), padding.large, padding.large);
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.desktop(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-left: -", ";\n    margin-right: -", ";\n  "], ["\n    margin-left: -", ";\n    margin-right: -", ";\n  "])), padding.base, padding.base);
});
export var PerksGOWrapper = styled(Flex)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), padding.base);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
